.ux-w-track-delivery-item {
    display: inline-block;
    min-width: 248px;
    max-width: 248px;
    padding: 20px 30px;

    &__order-number {
        @include font(light);
        margin-bottom: 15px;
        padding-bottom: 5px;
        font-size: 20px;
        border-bottom: 1px solid rgba($color-black, 0.2);
        position: relative;
        text-decoration: none;
        color: $color-black;
        display: block;

        ux-icon {
            right: 19px;
            top: 7px;
            position: absolute;
            font-size: 14px;
        }
    }

    & ~ & {
        .ux-w-track-delivery-item__order-number {
            margin-left: -60px;
        }

        .ux-w-track-delivery-item__order-number__content,
        .ux-w-track-delivery-item__order-number__icon {
            visibility: hidden;
        }
    }

    &__status {
        margin-top: 5px;
    }

    &__tracking-link {
        display: block;
        margin-top: 30px;
    }

    &__label {
        margin-top: 20px;
    }
}
